import { getHelsinkiDate } from './mergeReport';

type LicenseDates = {
    valid_from?: string | null;
    valid_until?: string | null;
    subscription_valid_from?: string | null;
    subscription_valid_until?: string | null;
};

const getLicenseDay = (value: string): string | undefined => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return undefined;

    // Database timestamps without an offset already contain the Helsinki calendar date.
    const datePrefix = value.match(/^\d{4}-\d{2}-\d{2}/)?.[0];
    const hasTimeZone = /(?:z|[+-]\d{2}(?::?\d{2})?)$/i.test(value.slice(10));
    return datePrefix && !hasTimeZone ? datePrefix : getHelsinkiDate(date);
};

const includesDay = (
    from: string | null | undefined,
    until: string | null | undefined,
    today: string
) => {
    const start = from ? getLicenseDay(from) : undefined;
    const end = until ? getLicenseDay(until) : undefined;
    return (
        (!from || (start !== undefined && start <= today)) &&
        (!until || (end !== undefined && end >= today))
    );
};

export const isLearnerSchoolLicenseValid = (
    license: LicenseDates,
    now = Date.now()
) => {
    const today = getHelsinkiDate(new Date(now));
    if (!includesDay(license.valid_from, license.valid_until, today))
        return false;

    if (
        'subscription_valid_from' in license ||
        'subscription_valid_until' in license
    ) {
        return Boolean(
            license.subscription_valid_from &&
            license.subscription_valid_until &&
            includesDay(
                license.subscription_valid_from,
                license.subscription_valid_until,
                today
            )
        );
    }

    return true;
};
